/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ExternalLinkIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M11 5a1 1 0 1 1 0 2H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 1 1 2 0v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3zm10-3q.084 0 .165.015l.026.004.01.002.03.006.061.016a1 1 0 0 1 .14.057l.043.02A1 1 0 0 1 22 3v6a1 1 0 1 1-2 0V5.414l-9.293 9.293a1 1 0 1 1-1.414-1.414L18.586 4H15a1 1 0 1 1 0-2z" /></svg>;
};
export default ExternalLinkIcon;